import { memo, ReactNode } from 'react';
import './Text.scss';

type TextProps = {
  children: ReactNode,
  variant:
    'title1' | // font-size: 74px
    'title2' | // font-size: 60px
    'subtitle1' | // font-size: 32px
    'subtitle2' | // font-size: 24px
    'content1' | // font-size: 20px
    'content2' | // font-size: 16px
    'content3' // font-size: 14px
  color?:
    'primary' | // black
    'secondary' | // white
    'tertiary' | // #8D8DB6
    'success' | // green
    'error', // red
  align?: 'left' | 'center' | 'right',
  weight?: 500 | 600 | 700,
  hasOpacity?: boolean,
  maxLines?: 1 | 2 | 3 | 4 | 5,
  className?: string,
  onClick?: () => void;
}

export const Text = memo(
  function Text(props: TextProps) {
    const {
      children,
      variant = 'content3',
      color= 'primary',
      align= 'left',
      weight= 400,
      hasOpacity,
      maxLines,
      className,
      onClick,
    } = props;
    const opacityClass = hasOpacity ? 'opacity' : '';
    const maxLinesClass = maxLines ? `max-lines-${maxLines}` : '';

    return (
      <p
        className={`text variant-${variant} color-${color} align-${align} weight-${weight} ${opacityClass} ${maxLinesClass} ${className}`}
        onClick={onClick}
      >
        {children}
      </p>
    );
  }
);